








import { Component, Vue } from 'vue-property-decorator';
import PostLanding from '../components/PostLanding.vue';
import CallToAction from '../components/CallToAction.vue';

@Component({ components: { PostLanding, CallToAction } })
export default class extends Vue {}
